import { render } from "./Identifier.vue?vue&type=template&id=3a219ade&scoped=true"
import script from "./Identifier.vue?vue&type=script&lang=js"
export * from "./Identifier.vue?vue&type=script&lang=js"

import "./Identifier.vue?vue&type=style&index=0&id=3a219ade&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a219ade"]])

export default __exports__